import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onBeforeMount } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import type { ParamCodeItem } from '@/typings/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
import CosInput from '@/components/Antd/CosInput/index.vue'
import request from '@/utils/request'

const __default__ = { name: 'ApplyCoupon' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<PotentialItem[]>([])
const formRef = ref()
const dataForm = ref<any>({})

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  list_activity: []
})
// 获取业务参数
const getByParamCodes = () => {
  request.post('lbu/api/coupons/listActivity').then((res) => {
    paramCodeData.value.list_activity = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const toggle = (data: PotentialItem[]) => {
  if (data.length !== 1) return DcMessage.error('每次只能选择一个客户发起')
  const item = data[0]
  if (!item.tmsCode && !item.customerSerial) {
    return DcMessage.error('仅能选择有客户代码或客户识别码的客户')
  }
  dataForm.value = {
    cosId: item.cosId
  }
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    const p = dataForm.value
    p.actName = paramCodeData.value.list_activity.find((item) => item.actCode === p.actCode)?.actName
    request
      .post('lbu/api/coupons/apply', dataForm.value)
      .then(() => {
        DcMessage.success('发券申请成功')
        visible.value = false
        emit('success')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
__expose({ toggle })

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "发券申请",
    width: "670px",
    "confirm-loading": loading.value,
    onOk: handleBecomeInvalidOk
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: dataForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "cosId",
                label: "客户名称"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosSelect, {
                    value: dataForm.value.cosId,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.cosId) = $event)),
                    options: selectedData.value,
                    fieldNames: { label: 'customerName', value: 'cosId' },
                    disabled: ""
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "actCode",
                label: "营销活动",
                span: 24,
                rules: {
          message: '请选择',
          required: true
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ParamCodesSelect, {
                    value: dataForm.value.actCode,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.actCode) = $event)),
                    options: paramCodeData.value.list_activity,
                    fieldNames: { label: 'actName', value: 'actCode' },
                    allowClear: ""
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "reason",
                label: "申请原因",
                rules: {
          message: '请输入',
          required: true
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(CosInput, {
                    value: dataForm.value.reason,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.reason) = $event)),
                    maxlength: 200
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})